<template>
	<div id="header" class="text-left">
		<div class="left full-height p-l-xl">
			<router-link :to="{ name: 'app' }"
				><h1>SOLAR PV FORECASTING TOOL</h1></router-link
			>
			<a href="https://energydata.info" target="_blank"
				><h4>ENERGYDATA.INFO</h4></a
			>
		</div>
		<div class="right full-height p-r">
			<div
				class="right relative"
				:style="{ lineHeight: header_height + 'px' }"
				v-for="(element, index) in menu_elements"
				v-bind:key="'header_menu_' + index"
				v-bind:class="{
					'm-r-lg': index != 0
				}"
			>
				<router-link
					:to="{
						name: element.route !== null ? element.route : $route.name
					}"
					v-bind:class="{
						'active-color': is_active(
							element.active ? element.active : element.route
						)
					}"
				>
					<div class="left m-r-sm">
						<font-awesome-icon :icon="element.icon" />
					</div>
					<div class="left">
						{{ element.name }}
					</div>
					<div
						v-if="element.route == 'portfolio'"
						class="header-separator"
					></div>
					<div class="clear"></div>
				</router-link>
			</div>
		</div>
		<div class="clear"></div>
	</div>
</template>

<script>
export default {
	name: "Header",
	props: ["header_height"],
	data: () => {
		return {
			menu_elements: [
				{ route: "contact", name: "Contact", icon: "envelope" },
				{
					route: "help-and-support-introduction",
					active: "help-and-support",
					name: "About",
					icon: "question-circle"
				},
				{ route: "portfolio", name: "Power forecasts", icon: "bolt" },
				{ route: "locations", name: "My PV plants", icon: "solar-panel" },
				{ route: "app", name: "Add PV plant", icon: "map" }
			]
		};
	},
	methods: {
		is_active(name) {
			for (var key in this.$route.matched) {
				if (this.$route.matched[key].name == name) return true;
			}
			return false;
		}
	}
};
</script>

<style>
#header {
	font-family: "Montserrat", sans-serif;
	color: white;
	-webkit-box-shadow: 0px 12px 17px -2px rgba(0, 0, 0, 0.7);
	box-shadow: 0px 12px 17px -2px rgba(0, 0, 0, 0.7);
	background-image: linear-gradient(to bottom, #00061c, #0c3d72);
}
#header h1 {
	font-size: 18px;
	margin: 10px 0 5px;
}
#header h4 {
	font-size: 12px;
	margin: -5px 0 0;
	font-weight: 400;
}
.header-separator {
	position: absolute;
	right: -15px;
	width: 1px;
	background-color: white;
	height: calc(100% - 20px);
	margin-top: 10px;
}
</style>
